import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import axios from 'axios';
import { useSelector } from 'react-redux';
import envConfig from '../../../bin/env.config';
import { Typography, Box } from '@material-ui/core';

export default function CompanyProductNoteDialog({ open, onClose, company_product_id }) {
  const token = useSelector((state) => state.session.token);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState('');

  // Fetch notes on open
  useEffect(() => {
    if (open && company_product_id) {
      fetchNotes();
    }
  }, [open, company_product_id]);

  const fetchNotes = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/company-product-note-history`, {
        company_product_id: company_product_id,
      }, {
        headers: { Authorization: token },
      });
      setNotes(res.data?.data || []);
    } catch (err) {
      setNotes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddNote = async () => {
    if (!newNote.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/company-product-note-insert`, {
        company_product_id: company_product_id,  
        note: newNote,
      }, {
        headers: { Authorization: token },
      });
      setNewNote('');
      fetchNotes();
    } catch (err) {
      // handle error
    } finally {
      setLoading(false);
    }
  };

  const handleEditNote = (note) => {
    setEditingId(note.id);
    setEditingText(note.note);
  };

  const handleUpdateNote = async (id) => {
    if (!editingText.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/company-product-note-update`, {
        id,
        note: editingText,
      }, {
        headers: { Authorization: token },
      });
      setEditingId(null);
      setEditingText('');
      fetchNotes();
    } catch (err) {
      // handle error
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteNote = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/company-product-note-delete`, {
        id,
      }, {
        headers: { Authorization: token },
      });
      fetchNotes();
    } catch (err) {
      // handle error
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Company Product Notes: {company_product_id}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <TextField
            style={{background:'#fbf8c3'}}
            multiline
            minRows={3}
            placeholder="Add a note..."
            value={newNote}
            onChange={e => setNewNote(e.target.value)}
            fullWidth
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" color="primary" onClick={handleAddNote} disabled={loading || !newNote.trim()}>
              Add note
            </Button>
          </div>
        </div>
        <div style={{ marginTop: 32 }}>
          {notes.length === 0 && <div style={{ color: '#888', textAlign: 'center' }}>No notes yet.</div>}
          {notes.map((note) => (
            <div key={note.id} style={{ marginBottom: 12, borderBottom: '1px solid #eee' }}>
              {editingId === note.id ? (
                <>
                  <TextField
                    style={{background:'#fbf8c3'}}
                    multiline
                    minRows={2}
                    value={editingText}
                    onChange={e => setEditingText(e.target.value)}
                    fullWidth
                  />
                  <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                    <Button size="small" color="primary" onClick={() => handleUpdateNote(note.id)} disabled={loading}>
                      Save
                    </Button>
                    <Button size="small" onClick={() => setEditingId(null)}>
                      Cancel
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', background:'#f4f4f4' }}>
                    <div style={{display:'flex', alignItems:'left'}}>
                      <span style={{margin: '4px 12px 0px 0px'}}>{note.edited_at}</span>
                      <span style={{margin: '4px 0 0 0px'}}>{note.edited_by}</span>
                    </div>
                    <div style={{display:'flex', gap:8, alignItems:'right'}}>
                      {note.editable>0&&<IconButton size="small" onClick={() => handleEditNote(note)}><EditIcon fontSize="small" /></IconButton>}
                      {note.editable>0&&<IconButton size="small" onClick={() => handleDeleteNote(note.id)}><DeleteIcon fontSize="small" /></IconButton>}
                    </div>
                  </div>
                  <div style={{ fontSize: 14, margin: '4px 0 8px 0' }}>{note.note}</div>
                </>
              )}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
} 